export enum EWaiters {
  CREATED = 'CREATED',
  ACCEPTED = 'ACCEPTED',
  FINISH = 'FINISH',
  CANCELED = 'CANCELED',
}


export default EWaiters;
